import { put, select } from 'redux-saga/effects';

import { clearError } from '../actions/chatActions';

/**
 * Get logged in user id
 */
export function* getOwnId() {
  return yield select(state => state.identity.id);
}

/**
 * Checks if error exists before pushing to reducers
 */
export function* clearErrorSaga(type) {
  const hasError = yield select(state => state.errors[type]);
  if (hasError) {
    yield put(clearError(type));
  }
}